/**
 * OfflineBanner - Visual indicator when user is offline
 *
 * Part of GAP-MOBILE-003: Offline Capabilities Phase 1
 * Created: 2025-12-31
 *
 * Features:
 * - Shows amber banner at top when offline
 * - Auto-hides when back online
 * - Positioned above safe-area for notch devices
 * - Uses Wifi Off icon from lucide-react
 */

import React from 'react';
import { WifiOff } from 'lucide-react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';

export function OfflineBanner() {
  const { isOnline } = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div
      className="fixed left-0 right-0 z-[100] bg-amber-500 text-white text-center py-2 px-4 text-sm font-medium flex items-center justify-center gap-2 shadow-md"
      style={{ top: 'var(--safe-area-top, 0px)' }}
    >
      <WifiOff className="w-4 h-4" />
      <span>You're offline - showing cached content</span>
    </div>
  );
}

export default OfflineBanner;
